/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from 'zod';
import { userDetailsGetResponseSchema } from './userDetailsGetResponseSchema.ts';

/**
 * @description 200 response
 */
export const getUserDetails200Schema = z.lazy(() => userDetailsGetResponseSchema);

/**
 * @description 505 response
 */
export const getUserDetails505Schema = z.any();

export const getUserDetailsQueryResponseSchema = z.lazy(() => getUserDetails200Schema);
